import React from 'react';
import { MessageBar, MessageBarProps, makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components';

type BannerTone = 'info' | 'warning' | 'error' | 'success';

const banner = (tone: BannerTone) => ({
  backgroundColor: `var(--ichtys-banner-${tone}-bg)`,
  ...shorthands.borderLeft('6px', 'solid', `var(--ichtys-banner-${tone}-bar)`),
  '& .fui-MessageBarTitle': {
    color: `var(--ichtys-banner-${tone}-bar)`,
    fontWeight: tokens.fontWeightBold,
  },
  '& .fui-MessageBar__icon': {
    color: `var(--ichtys-banner-${tone}-bar)`,
  },
});

const useGuideMessageBarStyles = makeStyles({
  base: {
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    // App.css limita .fui-MessageBarBody a 30vw (pensado para avisos flotantes): un banner de la
    // guía ocupa el ancho del bloque al que se refiere.
    '& .fui-MessageBarBody': {
      maxWidth: 'none',
    },
  },
  info: banner('info'),
  warning: banner('warning'),
  error: banner('error'),
  success: banner('success'),
});

/**
 * Banner de la guía ("Ayudas y mensajes"): barra izquierda gruesa del color, fondo tenue y borde
 * del tono, título bold en el color. Mismo API que el MessageBar de Fluent.
 */
export const GuideMessageBar = ({ className, intent = 'info', ...rest }: MessageBarProps) => {
  const styles = useGuideMessageBarStyles();
  const tone: BannerTone = intent ?? 'info';
  return (
    <MessageBar
      {...rest}
      intent={intent}
      data-intent={tone}
      className={mergeClasses('ichtys-banner', styles.base, styles[tone], className)}
    />
  );
};

export default GuideMessageBar;
